import React from 'react'

import SectionHeadline, {
  SectionHeadlineProps,
} from '@src/components/SectionHeadline'
import ArticleList, { ArticleListProps } from '@src/components/ArticleList'

import * as style from './style.module.sass'

type ArticleListSectionProps = {
  headlineProps: SectionHeadlineProps
  listProps: ArticleListProps
}

const ArticleListSection: React.FC<ArticleListSectionProps> = ({
  headlineProps,
  listProps,
}) => {
  const { navigateTo } = headlineProps
  const { articles } = listProps

  const checkedNavigateTo = articles.length > 0 ? navigateTo : undefined
  const checkedHeadlineProps = {
    ...headlineProps,
    navigateTo: checkedNavigateTo,
  }

  return (
    <SectionHeadline {...checkedHeadlineProps}>
      {articles.length > 0 ? (
        <>
          <ArticleList {...listProps} />
        </>
      ) : (
        <div className={style.coming}>Coming soon...</div>
      )}
    </SectionHeadline>
  )
}

export default ArticleListSection
